import "./Loader.css";

function Loader() {
    return (
        <div className="loader-overlay">
            <div className="loader-spinner"></div>
        </div>
    );
}

export default Loader;
